import { faClose } from '@fortawesome/free-solid-svg-icons'
import { faBicycle } from '@fortawesome/free-solid-svg-icons/faBicycle'
import { faCarSide } from '@fortawesome/free-solid-svg-icons/faCarSide'
import { faPersonWalking } from '@fortawesome/free-solid-svg-icons/faPersonWalking'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MarkerF } from '@react-google-maps/api'
import { DateTime } from 'luxon'
import * as React from 'react'
// import TimeAgo from 'react-timeago'
import { deviceFromPet } from '../../../helpers/dataHelpers.ts'
import { IDeviceStatus, IPet } from '../../../interfaces/types.ts'
import mapStore from '../../../store/mapStore.ts'
import { DATETIME_MED_WITH_WEEKDAY } from '../../events/ScrollControl.tsx'
import { getPawIcon } from '../components/icons.ts'
import { OverlayPanel } from '../components/OverlayPanel.tsx'
import './style.css'

interface Props {
    pet: IPet
    position: google.maps.LatLng
    status: IDeviceStatus
}

export const PetMarker: React.FC<Props> = (props) => {
    const {pet, position} = props
    const [open, setOpen] = React.useState(false)
    // const [near, setNear] = React.useState('')
    
    const markerInfo = mapStore(s => s.markerInfo)
    const myPosition = mapStore(s => s.myPosition)
    const directionsTo = mapStore(s => s.directionsTo)
    
    // const geocoder = new google.maps.Geocoder()
    
    const valid = Boolean(!!myPosition && !directionsTo)
    React.useEffect(() => {
        if (!markerInfo) {
            setOpen(false)
        }
    }, [markerInfo])
    
    const handleClick = () => {
        setOpen(!open)
        // if (!open) {
        //     doGeoCode()
        // }
        mapStore.getState().setMarkerInfo(!open ? pet._id : null)
    }
    
    const getDirections = (mode: google.maps.TravelMode) => {
        mapStore.getState().setDirectionsTo(position)
        mapStore.getState().setTravelMode(mode)
    }
    
    const device = deviceFromPet(pet)
    if (!device?.lastLocation || !Object.keys(device.lastLocation).length) {
        // bad data, can't render a device on the map with no location
        return null
    }
    
    // const date = DateTime.fromSeconds(device.lastLocation.properties.timeStamp).setZone(authStore.getState().timezone.value)
    // const literal = {
    //     lat: device.lastLocation.properties?.latitude,
    //     lng: device.lastLocation.properties?.longitude,
    // }
    // const latLng = new google.maps.LatLng(literal as any)
    
    // const doGeoCode = () => void geocoder.geocode({location: latLng}).then((response) => {
    //     if (response.results[0]) {
    //         setNear(response.results[0].formatted_address)
    //     }
    // })
    
    const directionButtons = (
        <div className={'flex flex-row w-full items-center justify-around'}>
            <button className={'btn btn-sm btn-primary btn-outline'}
                    onClick={() => getDirections(google.maps.TravelMode.WALKING)}
                    disabled={!valid}
            >
                <FontAwesomeIcon icon={faPersonWalking} size={'lg'}/>
            </button>
            <button className={'btn btn-sm btn-primary btn-outline'}
                    onClick={() => getDirections(google.maps.TravelMode.BICYCLING)}
                    disabled={!valid}
            >
                <FontAwesomeIcon icon={faBicycle} size={'lg'}/>
            </button>
            <button className={'btn btn-sm btn-primary btn-outline'}
                    onClick={() => getDirections(google.maps.TravelMode.DRIVING)}
                    disabled={!valid}
            >
                <FontAwesomeIcon icon={faCarSide} size={'lg'}/>
            </button>
        </div>
    )
    
    const petInfo = (
        <div className={'flex flex-col justify-start gap-2 select-none without-ring'}>
            <div className={'flex flex-row justify-between align-center'}>
                <div className={'w-4 h-1'}/>
                <div className={'text-lg font-semibold -mb-2'}>{pet.petName}</div>
                <div className={''}
                     onClick={() => setOpen(false)}>
                    <FontAwesomeIcon icon={faClose} fontSize={'small'} className={'focus:outline-none'}/>
                </div>
            </div>
            
            <div className={'flex flex-row justify-center text-lg align-center'}>
                <div>{DateTime.fromISO(device.lastLocation.properties.receivedTime).toLocaleString(DATETIME_MED_WITH_WEEKDAY)}</div>
                {/*<TimeAgo date={new Date(device.lastLocation.properties.receivedTime)}/>*/}
            </div>
            {/*<div className={'text-sm'}>Near {near}</div>*/}
            <div className={'flex items-center justify between'}>
                {/*<div className={'text-md font-bold'}>Directions</div>*/}
                {directionButtons}
            </div>
        </div>
    )

    return (
        <div className={'select-none no-outline'}>
            {open ?
                <OverlayPanel onClick={handleClick} position={position}>
                    {petInfo}
                </OverlayPanel>
                : null}
            <MarkerF key={pet._id}
                     position={position}
                     icon={getPawIcon(pet.iconColor, google)}
                     onClick={handleClick}
            />
        </div>
    )
}

